import { render, staticRenderFns } from "./AnnualYearStatement.vue?vue&type=template&id=d3685182"
import script from "./AnnualYearStatement.vue?vue&type=script&lang=js"
export * from "./AnnualYearStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports